module.exports = __webpack_public_path__ + "static/media/instant_hush_logo.73b8869b.png";